export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0037.e2e7d98b.webp";